import * as swcHelpers from '@swc/helpers';
import { initialFormState } from '../reducer.js';

// Default form control state when value is being prefilled
const seedFieldState = (key, value)=>{
    return {
        name: key,
        value,
        isValid: false,
        isTouched: true
    };
};
const seedFormData = (fields, formValues)=>{
    return fields.reduce((formData, fieldName)=>{
        const fieldValue = formValues[fieldName];
        return swcHelpers.objectSpread({}, formData, fieldValue ? {
            [fieldName]: seedFieldState(fieldName, fieldValue)
        } : {});
    }, {});
};
const seedInitialFormState = (fields)=>{
    const formState = {
        formData: {}
    };
    fields.forEach((fieldName)=>{
        formState.formData[fieldName] = {
            name: fieldName,
            value: '',
            isValid: false,
            isTouched: false
        };
    });
    return formState;
};
const seedShippingForm = (fields, formValues, form)=>{
    const formData = swcHelpers.objectSpread({}, form === null || form === void 0 ? void 0 : form.formData, seedFormData(fields, formValues));
    return Object.keys(formData).length ? swcHelpers.objectSpread({}, form || initialFormState, {
        formData: swcHelpers.objectSpread({}, form === null || form === void 0 ? void 0 : form.formData, seedFormData(fields, formValues))
    }) : undefined;
};

export { seedFieldState, seedInitialFormState, seedShippingForm };
//# sourceMappingURL=seed-shipping-form.js.map
